module.exports = __webpack_public_path__ + "media/images/icons/alchemy-381da87b31f6fa4bc6b6aa751f3dd20b.svg";